import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "py-4 bg-gray-50/50 border border-gray-200 rounded-3xl"
}

import { reactive, toRefs } from 'vue';
import { JsonExplorerNode as Node } from '@/models';


export default /*#__PURE__*/_defineComponent({
  props: {
    json: null,
    depth: { default: 1 },
    raw: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { json: unknown, depth: number, raw: boolean }



const { json, depth, raw } = toRefs(props);
const node = reactive(new Node(json.value, null, '', 0, depth.value));

return (_ctx: any,_cache: any) => {
  const _component_json_explorer_node = _resolveComponent("json-explorer-node")!

  return (_unref(raw))
    ? (_openBlock(), _createBlock(_component_json_explorer_node, {
        key: 0,
        node: _unref(node)
      }, null, 8, ["node"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_json_explorer_node, { node: _unref(node) }, null, 8, ["node"])
      ]))
}
}

})